<template>
  <div>
    {{ data.priceSell }} {{ data.currencySell.code }} ({{data.incotermSell.name }})
  </div>
</template>

<script>

export default {
  props: ['data', 'index', 'column'],
}
</script>



// WEBPACK FOOTER //
// src/table/ColumnPriceSell.vue